import { Component, OnInit } from '@angular/core';
import { userAuthorizationService } from './user-authorization.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-authorization',
  templateUrl: './user-authorization.component.html',
  styleUrls: ['./user-authorization.component.scss']
})
export class UserAuthorizationComponent implements OnInit {

  constructor(public userAuth: userAuthorizationService,
    private router: Router) { }

  ngOnInit() {
  }

  performNavigation() {
      this.router.navigate(['/']);
  }

}
